module.exports = __webpack_public_path__ + "static/img/wxQrCode.d95142d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wxQrCode.jpg
// module id = 4u2S
// module chunks = 0